<div class="wrapper">

  <div class="topbar campaign clearfix">
    <div class="logo-picto">
      <a routerLink="/">
        <img class="logo-picto" src="assets/layout/images/logo-picto.png" alt="" srcset="assets/layout/images/logo-picto@2x.png 2x, assets/layout/images/logo-picto@3x.png 3x" />
      </a>
    </div>
    <div id="topbar-icons" class="animated">
      <span class="topbar-search">
        <h1>{{ campaign?.name }}</h1>
      </span>
      <div class="icon-right">
        <a routerLink="/support" target="_blank">
          <span class="topbar-campaign-icon fa fa-life-ring animated swing"></span>
          <span class="topbar-campaign-item-text">{{ 'campaign.support' | translate }}</span>
        </a>
        <button pButton type="button" class="SaveExit" label="{{ 'campaign.exitButton' | translate }}" routerLink="/campaign-list"></button>
      </div>
    </div>
  </div>

  <div class="campaignstatus clearfix">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6">
        <div class="status-left">
          {{ 'campaign.finalEvaluation' | translate }}
        </div>
      </div>
      <div class="ui-g-6">
        <div class="status-right">
          {{ 'campaign.campaignStatus' | translate}}: <span class="status-evaluated">{{ 'campaign.evaluated' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigninfo">
    <div class="ui-g ui-fluid">
      <div class="ui-g-2">
        <h2>{{ 'campaign.budgetOverview' | translate }}</h2>
      </div>
      <div class="ui-g-10 ui-g-nopad">
        <div class="ui-g-3 infobox">
          <div>{{ 'campaign.budget' | translate }}</div>
          <div class="infobox-value">{{ campaign?.budget | numberKM }} &euro;</div>
        </div>
        <div class="ui-g-3 infobox">
          <div>{{ 'campaign.realCost' | translate }}</div>
          <div class="infobox-value">{{ budget | numberKM }} &euro;</div>
        </div>
        <div class="ui-g-3 infobox">
          <div>{{ 'campaign.incrementalSpent' | translate }}</div>
          <div class="infobox-value">{{ incrementalSpent | numberKM }} &euro;</div>
        </div>
        <div class="ui-g-3 infobox">
          <div>{{ 'campaign.roi' | translate }}</div>
          <div class="infobox-value">{{ roi }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigncharts">

    <div class="ui-g ui-fluid">
      <div class="ui-g-8 ui-g-nopad left-chart">
        <h2>{{ 'campaign.incrementalSpent' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="charts.incrementalSpent.options" (load)="chartInstance(charts.incrementalSpent, $event.context)"></chart>
        </div>
      </div>
      <div class="ui-g-4 ui-g-nopad right-chart">
        <h2>{{ 'campaign.budgetPerType' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="charts.budgetPerType.options" (load)="chartInstance(charts.budgetPerType, $event.context)"></chart>
        </div>
      </div>
      <div class="ui-g-6 ui-g-nopad left-chart">
        <h2>{{ 'campaign.redemptionPerCluster' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="charts.redemptionPerCluster.options" (load)="chartInstance(charts.redemptionPerCluster, $event.context)"></chart>
        </div>
      </div>
      <div class="ui-g-6 ui-g-nopad right-chart">
        <h2>{{ 'campaign.estimatedVsActual' | translate }}</h2>
        <div class="chart-container">
          <button pButton type="button" class="roundedButton slim border status status-all" [class.active]="visibleSerie == 'emission'" label="{{ 'campaign.emission' | translate }}" (click)="updateSeries('emission')"></button>
          <button pButton type="button" class="roundedButton slim border status status-all" [class.active]="visibleSerie == 'redemption'" label="{{ 'campaign.redemption' | translate }}" (click)="updateSeries('redemption')"></button>
          <chart [options]="charts.emissionRedemption.options" (load)="chartInstance(charts.emissionRedemption, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/final-evaluation/final-evaluation.component.html